// 权限公用
import { ENUM_ROLE_TYPE } from '@/common/enum/forward/account'

export const getPermission = function () {
  const currentUser = vm.$store.getters.userInfo.scope
  if (currentUser.sysScope && currentUser.sysAdmin) {
    // 系统管理员
    return 'isSysAdmin'
  } else if (currentUser.sysScope && !currentUser.sysAdmin) {
    // 系统非管理员
    return 'isSysNoAdmin'
  } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
    // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
    return 'noSysIsAdmin'
  } else {
    // 非系统非管理员
    return 'noSysNoAdmin'
  }
}
// 判断是否系统用户
export const getIsSys = function () {
  const permission = getPermission()
  if (permission === 'noSysIsAdmin' || permission === 'noSysNoAdmin') {
    return false
  }
  return true
}

// 获取是否平台用户
export const getIsPlatform = function () {
  const type = vm.$store.state.type
  // 平台管理或平台使用
  if (type === ENUM_ROLE_TYPE.PLATFORM_MANA || type === ENUM_ROLE_TYPE.PLATFORM_USE) {
    return true
  }
  return false
}

// 按钮权限判断
export const hasPermission = function (value) {
  // 拥有的权限
  const roles = window.vm.$store.state.auth || JSON.parse(sessionStorage.getItem('BtnPromision')) || [] // 获取mate中的权限
  if (value && value instanceof Array && value.length > 0) {
    const hasPermission = value.every(item => roles[item])
    return hasPermission
  }
  return false
}
